import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import Footer from '../Common/Footer';
import Header from '../Common/Header';
import TopNav from '../Nav/TopNav';

const MainLayout = (props) => {
    const {pathname}=props.location;

    return ( 
        <Fragment>
        <div className="landing-layer">
                <TopNav />
                {pathname==="/"?<Header />: <div className='curve'></div>}
               
        </div>
        <main id="home-page">
            <div>{props.children} </div>
        </main>
        
        <Footer />
    </Fragment>
     );
}

export default withRouter(MainLayout);